import routes from './routes';

export default {
    routes,
    moduleName: "Network_Intro"
};